export default __webpack_public_path__ + "static/media/morning.95a93cdc.jpg";